import { FormEvent, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../components/Logo";
import { resetPassword } from "../../api/authEtablissement";

const RESET_EMAIL_KEY = "agbaza.reset.email";
export { RESET_EMAIL_KEY };

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export default function EtablissementForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const emailValid = useMemo(() => emailRegex.test(email.trim()), [email]);
  const canSubmit = emailValid && !submitting;

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!canSubmit) return;
    setError("");
    setSubmitting(true);
    const result = await resetPassword(email.trim());
    setSubmitting(false);
    if (result.ok) {
      sessionStorage.setItem(RESET_EMAIL_KEY, email.trim());
      navigate("/etablissement/mot-de-passe/code");
    } else {
      setError(result.message || "Une erreur est survenue");
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 relative">
      {/* Mobile background image */}
      <div className="absolute inset-0 md:hidden">
        <img src={'/maps-login-side.jpg'} alt="forgot" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/30" />
      </div>

      {/* Left: form */}
      <div className="relative flex items-center justify-center px-4 md:px-10 py-10">
        <div className="w-full max-w-md">
          <div className="flex justify-center"><Logo size={56} /></div>
          <h1 className="mt-6 text-2xl md:text-3xl font-semibold text-[#0B1F16]">
            Récupération du mot de passe
          </h1>
          <p className="mt-2 text-sm text-gray-600">Entrez votre email et nous vous enverrons un code de vérification.</p>
          <form className="mt-6 space-y-4" onSubmit={onSubmit}>
            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-[10px] px-3 py-2">
                {error}
              </div>
            )}
            <div className="space-y-2">
              <label className="text-sm text-[#0B1F16]">Email</label>
              <input
                type="email"
                placeholder="exemple@domaine.com"
                value={email}
                onChange={(event) => setEmail(event.target.value.replace(/\s/g, ""))}
                className={`w-full h-12 rounded-[10px] border px-3 bg-white ${emailValid || email === '' ? 'border-[#E5E7EB]' : 'border-red-400'}`}
              />
            </div>
            <button
              type="submit"
              disabled={!canSubmit}
              className="w-full h-12 rounded-[10px] font-semibold cursor-pointer disabled:opacity-60"
              style={{ backgroundColor: "#00553E", color: "#FFFFFF" }}
            >
              {submitting ? "Envoi…" : "Envoyer le code"}
            </button>
            <Link to="/etablissement/connexion" className="block">
              <button type="button" className="w-full h-12 rounded-[10px] font-semibold border cursor-pointer" style={{ borderColor: "#D1E2DD", color: "#00553E" }}>
                Retour
              </button>
            </Link>
          </form>
        </div>
      </div>
      {/* Right: image (desktop) */}
      <div className="relative hidden md:block">
        <img src={'/maps-login-side.jpg'} alt="forgot" className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </div>
  );
}
